var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"trigger":"click","interval":5000,"width":"100%","height":"80vh"}},_vm._l((_vm.imgList),function(item,index){return _c('el-carousel-item',{key:index},[_c('el-image',{staticStyle:{"width":"100%","height":"80vh"},attrs:{"src":item.url}})],1)}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec9d26c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Home/index.vue
// module id = null
// module chunks = 